import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HelpRequestIcon from '../../../assets/img/planner-help-icon.svg';
import HomeIcon from '@material-ui/icons/Home';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import HelpOutlineIcon from '@material-ui/icons/Timer';
import { dateToS } from '../../../util/dateUtil';
import { isStudent, isAlumni, isAdminOrFHT } from '../../../util/miscUtil';

const HelpApps = ({
  senior,
  roles,
  aftercareSpecialist,
  formatPhoneNumber,
  helpAppList,
  setPage,
  handleReturnToSeniorList,
  handleCreateHelpApp,
  openHelpApp,
  summarizeHelpOptions,
  displayStatus,
  classes,
  handleGotoAdminHomepage,
}) => {
  window.scrollTo({ top: 0 });

  return (
    <summary className={classes.subPageContainer}>
      <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}>
        <div className={classes.centerForm}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {
                xs: '380px',
                sm: '540px',
                md: '868px',
                lg: '1320px',
                xl: '1320px',
              },
            }}
          >
            <Grid container spacing={0} direction="row">
              <Grid item xs={12} align="left">
                <summary className={classes.header} style={{ paddingTop: '30px' }}>
                  <Grid container direction="row" style={{ width: '100%' }}>
                    <Grid item xs={false} sm={1} md={1} lg={1} align="center" className={classes.logoContainer}>
                      <img src={HelpRequestIcon} alt="Help Requests Icon" className={classes.logo} />
                    </Grid>
                    <Grid item xs={12} sm={11} md={11} lg={11} align="left">
                      <Grid container spacing={0} direction="row" style={{ width: '100%' }}>
                        <Grid item xs={9} sm={10} md={10} lg={11} align="left" style={{ width: '100%' }}>
                          <div className={classes.headerContent}>
                            <div className={classes.headerText}>
                              <div className={classes.title}>
                                {isStudent(roles) || isAlumni(roles) ? (
                                  <main>Help Requests</main>
                                ) : (
                                  <main>
                                    Help Requests for {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                                    {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                                  </main>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={2} md={2} lg={1} align="center" style={{ width: '100%' }}>
                          <IconButton color="inherit" aria-label="return home" onClick={() => setPage('home')}>
                            <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} style={{ marginTop: '15px' }}>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Successful Futures Specialist:</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                                ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                                : 'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Office Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.office_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Cell Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.cell_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </summary>
              </Grid>
            </Grid>
          </Box>
        </div>

        {!isStudent(roles) && !isAlumni(roles) && (
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1280px',
                  xl: '1280px',
                },
              }}
            >
              <div className={classes.breadcrumbs}>
                <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={handleGotoAdminHomepage}>
                    <HomeIcon style={{ fontSize: '1.30rem' }} />
                    <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={handleReturnToSeniorList}>
                    Alumni
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={() => setPage('home')}>
                    {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                    {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                  </span>
                  <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                    Help Requests
                  </span>
                </Breadcrumbs>
              </div>
            </Box>
          </div>
        )}
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1280px',
              xl: '1280px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" className={classes.menu}>
            {isAdminOrFHT(roles) && helpAppList.length === 0 && (
              <Grid item xs={12} align="center">
                <summary className={classes.noApps}>{senior.first_name} does not have any Help Requests.</summary>
              </Grid>
            )}
          </Grid>
        </Box>
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1320px',
              xl: '1320px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" style={{ marginTop: '75px' }}>
            <Grid item xs={12} align="left" className={classes.cardGrid} style={{ width: '99%' }}>
              {isAlumni(roles) && (
                <nav onClick={handleCreateHelpApp} className={classes.nav}>
                  <Card className={classes.card}>
                    <CardBody className={classes.cardBody}>
                      <div className={classes.cardContainer}>
                        <img src={HelpRequestIcon} alt="Help Requests Icon" className={classes.cardIcon} />
                        <Tooltip title="Click to create a new Help Request" placement="bottom">
                          <section className={classes.addSection}>
                            <AddIcon className={classes.addIcon} />
                          </section>
                        </Tooltip>
                      </div>
                    </CardBody>
                  </Card>
                </nav>
              )}
              {helpAppList
                .slice()
                .sort((a, b) => b.id - a.id)
                .map((app) => {
                  return (
                    <nav onClick={() => openHelpApp(app.id)} className={classes.nav}>
                      <Card className={classes.card}>
                        <CardBody className={classes.cardBody}>
                          <div className={classes.cardContainer}>
                            <img src={HelpRequestIcon} alt="Help Requests Icon" className={classes.cardIcon} />
                            <section className={classes.helpSubmittedDate}>
                              <span className={classes.cardHeader}>{(app.submitted_date && dateToS(app.submitted_date)) || 'Unsubmitted'}</span>
                            </section>
                            <aside className={classes.helpOptionsList}>
                              {(() => {
                                const options = summarizeHelpOptions(app.application) || [];
                                return options.toString().length > 40 ? options.join(', ').substr(0, 35) + '...' : options.join(', ');
                              })()}
                            </aside>
                            <summary className={classes.statusBottom}>
                              <section className={classes.appStatus}>
                                {app.status === 'closed' ? (
                                  <CheckIcon className={classes.statusIcon} />
                                ) : (
                                  <HelpOutlineIcon className={classes.statusIcon} />
                                )}{' '}
                                <span className={classes.iconText}>{displayStatus(app.status.toLowerCase())}</span>
                              </section>
                              <section className={classes.appStatusDate}>
                                <span className={classes.iconText}>{dateToS(app.status_date)}</span>
                              </section>
                            </summary>
                          </div>
                        </CardBody>
                      </Card>
                    </nav>
                  );
                })}
            </Grid>
          </Grid>
        </Box>
      </div>
    </summary>
  );
};

HelpApps.propTypes = {
  senior: PropTypes.object,
  roles: PropTypes.array,
  aftercareSpecialist: PropTypes.object,
  formatPhoneNumber: PropTypes.func,
  helpAppList: PropTypes.array,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  handleCreateHelpApp: PropTypes.func,
  openHelpApp: PropTypes.func,
  summarizeHelpOptions: PropTypes.func,
  displayStatus: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default HelpApps;
